import React, {useState} from 'react';
import first from '../static/pictures/Join_pictures/first.jpg'
//import "../static/css/Contact.css"

function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
    })

    const SERVER_API = "https://bell-project-backend.fly.dev"

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${SERVER_API}/clients/add_client`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            })

            if (!response.ok) throw new Error("Помилка при відправці");
            alert("Данні відправленно успішно!");

        } catch (error) {
            console.error("Помилка:", error);
        }
    }

    return(
        <div className='join_body'>
            <section className='how_to_join_section'>
                <div>
                    <h2>Як пройти психотерапію</h2>
                    <p>
                        
                        Після надсилання вашого імені та номеру телефону, до вас подзвонять у вільний час і домовляться про перший дзвінок для ознайомлення з вами.
                    </p>
                    <div className='join_form'>
                        <h1>Зареєструватись на терапію</h1>
                        <form onSubmit={handleSubmit}>
                            <label>Ім'я</label>
                            <input type='text' id='name-upload' name='name-upload' value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} placeholder='Name'/>
                            <label>Телефон</label>
                            <input type='text' id='phone-upload' name='phone-upload' value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} placeholder='Phone number (+380)__________'/>
                            <button type='submit'>Відправити</button>
                        </form>
                    </div>
                </div>
                <img src={first} alt='first_photo'/>
            </section>
        </div>
    );
}

export default Contact;
